/**
 * Modal component for displaying summarized content result
 */

import React, { useEffect, useState } from 'react'
import { Modal, Button, Divider, Tooltip, Icon, message, Input } from 'antd'
import { useTranslation } from 'react-i18next'

const SummarizedContentModal = ({
  visible,
  onCancel,
  onUse,
  onApplyAll,
  summarizedContent,
  originalContentLength,
  isApplyingAll,
  onUndo,
  onContentChange
}) => {
  const [isConfirmVisible, setIsConfirmVisible] = useState(false)
  const [editedContent, setEditedContent] = useState(summarizedContent || '')

  useEffect(() => {
    if (visible) {
      setEditedContent(summarizedContent || '')
    }
  }, [visible, summarizedContent])

  const { t } = useTranslation()

  return (
    <Modal
      title={t('v5:edited_content')}
      visible={visible}
      onCancel={onCancel}
      centered
      className="ai-summarized-content-result"
      footer={
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            width: '100%'
          }}
        >
          <div>
            <Button onClick={onUndo} className="shl-secondary-btn" size="small">
              {t('v4:undo')}
            </Button>
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <Button
              onClick={() => setIsConfirmVisible(true)}
              className="shl-secondary-btn"
              size="small"
              loading={isApplyingAll}
            >
              {t('v4:apply_all')}
            </Button>
            <Button
              type="primary"
              onClick={() => onUse(editedContent)}
              className="shl-primary-btn"
              size="small"
            >
              {t('v4:use_this_content')}
            </Button>
          </div>
        </div>
      }
    >
      <div className="ai-summarized-content-inner">
        <div
          style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}
        >
          <span style={{ color: 'rgba(0,0,0,0.45)', marginRight: 16 }}>
            {t('v4:original')}: <strong>{originalContentLength}</strong> chars
          </span>
          <span style={{ color: 'rgba(0,0,0,0.45)', marginRight: 16 }}>
            {t('v4:edited')}: <strong>{editedContent.length}</strong> chars
          </span>
          <span style={{ color: 'rgba(0,0,0,0.45)', marginRight: 16 }}>
            {t('v2:change')}:{' '}
            <strong>
              {editedContent.length - (originalContentLength || 0)}
            </strong>
          </span>
        </div>
        <Divider />
        <div className="summarized-content-preview">
          <h4 style={{ marginBottom: 8 }}>{t('v4:edited_content_preview')}</h4>
          <Input.TextArea
            value={editedContent}
            onChange={e => {
              const value = e.target ? e.target.value : ''
              setEditedContent(value)
            }}
            autosize={{ minRows: 8 }}
          />
        </div>
      </div>

      <Modal
        title={t('v4:apply_edits_to_all_topices')}
        visible={visible && isConfirmVisible}
        onCancel={() => setIsConfirmVisible(false)}
        centered
        footer={[
          <Button
            key="cancel"
            onClick={() => setIsConfirmVisible(false)}
            size="small"
          >
            {t('buttons:cancel')}
          </Button>,
          <Button
            key="confirm"
            type="primary"
            onClick={() => {
              if (onContentChange) onContentChange(editedContent)
              if (onApplyAll) onApplyAll()
            }}
            className="shl-primary-btn"
            loading={isApplyingAll}
            size="small"
          >
            {t('v4:apply_to_all')}
          </Button>
        ]}
      >
        <div>
          {t('v4:current_editing_instructions_across_the_whole_course')}
        </div>
      </Modal>
    </Modal>
  )
}

export default SummarizedContentModal
